import { createFileRoute, redirect } from '@tanstack/react-router'
import { CheckYourInboxPage } from '@/pages/auth/login/CheckYourInboxPage'
import { AuthCheckYourInboxSearchSchema } from '@/schemas/page'

export const Route = createFileRoute('/auth/check-your-inbox')({
  validateSearch: AuthCheckYourInboxSearchSchema,
  beforeLoad: ({ context, search }) => {
    if (context.authContext.isAuthenticated) {
      return redirect({
        to: '/home',
      })
    }
    if (!search.email) {
      throw redirect({
        to: '/auth/reset-password',
      })
    }
  },
  component: CheckYourInboxPage,
})
